module.exports = {
  accessset: {
    errorloading: "Les données n'ont pas pu être chargées.",
    saveerror: {
      unknown: "L'accès n'a pas pu être enregistré.",
      noRights: "Vous n'avez pas les droits sur ce logement.",
      accessNotFound: "Cet accès n'existe plus : il a probablement été supprimé entre-temps.",
      addFailed: "L'accès n'a pas pu être enregistré : il a peut-être été modifié entre-temps. Réessayez.",
      argMissings: "Il manque une information pour enregistrer cet accès.",
      notAuthentified: "Votre session a expiré, reconnectez-vous."
    },
    listerror: {
      unknown: "Une liste n'a pas pu être chargée. Votre saisie est conservée, réessayez votre sélection.",
      housingGroup: "La liste des bâtiments n'a pas pu être chargée. Votre saisie est conservée, réessayez votre sélection.",
      housing: "La liste des logements n'a pas pu être chargée. Votre saisie est conservée, réessayez votre sélection."
    },
    form: {
      reactivate: 'Réactiver',
      createat: 'Créée le',
      datestart: {
        title: "Début de la validité"
      },
      dateend: {
        title: "Fin de la validité"
      },
      deactivate: 'Désactiver',
      housing: {
        title: "Logement",
        none: "Tous les logements de ce bâtiment"
      },
      housinggroup: {
        title: "Bâtiment",
        none: "Tous les bâtiments de cette copropriété"
      },
      jointhousinggroup: {
        title: "Copropriété",
        none: "Toutes les copropriétés"
      },
      reference: {
        title: "Destinataire"
      },
      validate_add: 'Ajouter',
      validate_modify: 'Modifier'
    },
    title_add: 'Ajouter un accès',
    title_modify: 'Modifier un accès'
  },
  accessview: {
    errorloading: "Les données n'ont pas pu être chargées.",
    intro: '',
    intro_10:
      'La clé ci-dessous vous permet de créer un compte administrateur. Pour créer votre compte, rendez-vous sur : ',
    print: "Imprimer l'invitation",
    sendinvite: "Télécharger l'invitation au format pdf",
  },
  activateaccount: {
    housinggroup: {
      label: "Copropriété :"
    },
    housing: {
      label: "N° :"
    },
    user: {
      label: "Nom :"
    },
    usergroup: {
      label: "Syndic :"
    },
    title: "Création Espace Personnel - Utilisateur",
    title_10: "Création Espace Personnel - Administrateur",
    title_20: "Création Espace Personnel - Utilisateur Syndic",
    title_30: "Création Espace Personnel - Utilisateur Technicien",
    intro1: "Madame, Monsieur.",
    intro2: "Voici la clef d’identification vous permettant de créer un accès sécurisé à la consultation de vos consommations personnelles :",
    intro2_20: "Voici la clef d’identification vous permettant de créer un accès sécurisé à la consultation de la consommation de vos coproprietés :",
    processus1: "Procédure d’activation de votre compte :",
    processus2: "Rendez-vous sur le site :",
    processus3: "Cliquez sur le lien suivant : Vous avez une clé d'accès et pas de compte ? Créez-en un",
    processus4: "Vous devez saisir la clef mentionnée sur ce courrier, ainsi qu’une adresse mail et un mot de passe sécurisé.",
    processus5: "(Le mot de passe doit contenir au minimum 8 caractères, une majuscule, une minuscule et un chiffre).",
    processus6: "Vous recevrez un mail avec un lien de confirmation à valider pour terminer la procédure.",
    processus7: "Vous pouvez vous reconnecter, votre compte est activé.",
    footer: "Siège Social : 61 bis rue Paul Bert – 94130 NOGENT SUR MARNE – SARL au capital de 2500 € - RCS Créteil – SIRET 901 941 070"
  },
  adminremoteaccess: {
    title: 'Accès de télérelevé',
    intro: "Plusieurs accès du même type peuvent coexister, chacun avec sa connexion et son horaire de déclenchement. Un accès dont le serveur, l'utilisateur ou le répertoire n'est pas renseigné n'est pas planifié.",
    accessrefused: "Accès refusé : cette page est réservée au superadmin.",
    newaccess: 'Nouvel accès',
    notypeaccess: "Aucun accès de ce type pour l'instant.",
    addaccess: 'Ajouter un accès',
    create: 'Créer',
    cancel: 'Annuler',
    save: 'Enregistrer',
    saved: 'Enregistré',
    enable: 'Activer',
    disable: 'Désactiver',
    disabled: 'Désactivé',
    duplicate: 'Dupliquer',
    remove: 'Supprimer',
    removeconfirm: 'Supprimer cet accès ? Ses imports cessent et il disparaît de cette page.',
    removeyes: 'Confirmer la suppression',
    testing: 'Test en cours…',
    copysuffix: '(copie)',
    lastrun: 'Dernière exécution :',
    lasttest: 'Dernier test :',
    neverrun: 'Jamais exécuté',
    manualonly: 'Déclenchement manuel',
    emptymeansenv: "Serveur, utilisateur et répertoire sont indispensables : tant qu'ils ne sont pas renseignés, l'accès n'est pas planifié. Le port vaut 21 par défaut, un horaire vide signifie « déclenchement manuel ».",
    passwordhint: 'Non consultable : saisir une valeur pour la remplacer, laisser vide pour ne rien changer.',
    field: {
      type: 'Type',
      label: 'Libellé',
      cron: 'Horaire',
      host: 'Serveur',
      port: 'Port',
      user: 'Utilisateur',
      password: 'Mot de passe',
      path: 'Répertoire',
      url: 'URL'
    },
    test: {
      action: 'Tester',
      ok: 'Connexion réussie — {{count}} fichier(s) visible(s), {{ms}} ms',
      okshort: 'connexion réussie',
      step: {
        connect: '(à la connexion)',
        auth: "(à l'authentification)",
        path: '(à l\'accès au répertoire)',
        list: '(au listage)'
      },
      error: {
        timeout: 'Délai dépassé',
        connectionRefused: 'Connexion refusée',
        hostNotFound: 'Serveur introuvable',
        unreachable: 'Serveur injoignable',
        authFailed: 'Identifiants refusés',
        pathNotFound: 'Répertoire introuvable',
        listFailed: 'Listage impossible',
        httpError: 'Réponse en erreur',
        urlMissing: 'URL non définie',
        hostMissing: 'Serveur non défini',
        noConnection: 'Configuration incomplète'
      }
    },
    error: {
      unknownAccessType: "Ce type d'accès n'est pas pris en charge.",
      requiredField: 'Le champ « {{field}} » est obligatoire.',
      invalidPort: 'Le port doit être compris entre 1 et 65535.',
      invalidCron: 'Expression cron invalide. Format attendu : 5 ou 6 champs, par exemple « 0 30 4 * * * ».',
      duplicateAccess: 'Un accès identique existe déjà : même serveur, même port, même utilisateur et même répertoire.',
      accessNotFound: "Cet accès n'existe plus.",
      remoteAccessNotFound: "Cet accès n'existe plus.",
      tooManyTests: 'Trop de tests de connexion en peu de temps. Patientez une minute.',
      settingsEncryptionKeyMissing: "Aucune clé de chiffrement configurée : définir SETTINGS_ENCRYPTION_KEY côté serveur.",
      settingsEncryptionKeyUnknown: 'Le mot de passe en base a été chiffré avec une clé inconnue du serveur.',
      cipherAuthFailed: 'Le mot de passe chiffré en base est corrompu.',
      notAllow: 'Action réservée au superadmin.',
      notAuthentified: 'Session expirée, reconnectez-vous.',
      unknown: 'Une erreur est survenue.'
    }
  },
  adminsettings: {
    title: 'Paramétrage applicatif',
    accessrefused: "Accès refusé : cette page est réservée au superadmin.",
    save: 'Enregistrer',
    saved: 'Enregistré',
    reset: 'Réinitialiser',
    listhint: 'Valeurs séparées par des virgules.',
    secretplaceholder: 'Saisir une nouvelle valeur pour remplacer',
    unsethint: "Laissé vide, la valeur définie dans l'environnement du serveur s'applique.",
    effective: {
      env: "Valeur appliquée, définie dans l'environnement du serveur :",
      code: 'Valeur appliquée, issue des valeurs par défaut du code :',
      none: 'Aucune valeur définie.'
    },
    cronplaceholder: '0 30 4 * * *',
    history: {
      show: 'Historique',
      hide: 'Masquer l\'historique',
      loading: 'Chargement de l\'historique…',
      empty: 'Aucune modification enregistrée pour ce paramètre.',
      restore: 'Restaurer',
      notrestorable: 'Non restaurable',
      novalue: '(non défini)',
      unknownauthor: 'Auteur inconnu'
    },
    cronhint: 'Expression cron : seconde minute heure jour mois jour_semaine. La modification prend effet immédiatement, sans redémarrage.',
    secrethint: 'Secret non consultable : il ne peut être que remplacé. Minimum {{count}} caractères. Laisser vide pour ne rien changer.',
    category: {
      thresholds: 'Seuils',
      cron: 'Tâches planifiées',
      email: 'Messagerie',
      maintenance: 'Maintenance',
      performance: 'Performance',
      remoteMeter: 'Télérelevé',
      general: 'Général'
    },
    field: {
      dailyMeterNbDay: 'Relevé quotidien manquant',
      boxNbDay: 'Fichier boîtier manquant',
      partialNoFlowNbDay: "Débit partiel nul : période d'analyse",
      partialNoFlowVol: 'Débit partiel nul : volume plancher',
      inverseFlowThreshold: 'Seuil de débit inverse',
      negativeFlowThreshold: 'Seuil de débit négatif',
      webdynImportChunkSize: 'Import Webdyn : taille de lot',
      negativeFlowDeviceChunkSize: 'Débits négatifs : appareils par lot',
      negativeFlowCacheTtlMinutes: 'Débits négatifs : durée du cache',
      notifHistoryRetentionDays: 'Rétention des rapports d\'alarmes envoyés',
      meterKeyBmeter1: 'Clé B Meters',
      meterKeyDiehl1: 'Clé Diehl (eau et chauffage)',
      meterKeyMaddalena1: 'Clé Maddalena'
    },
    error: {
      invalidnumber: 'Toutes les valeurs doivent être des nombres valides.',
      invalidNumber: 'Toutes les valeurs doivent être des nombres valides.',
      notInteger: 'La valeur de « {{field}} » doit être un nombre entier.',
      outOfRange: 'La valeur de « {{field}} » est en dehors des bornes autorisées.',
      invalidObject: 'Le format attendu est un ensemble de champs.',
      missingEntry: 'La valeur de « {{field}} » est manquante.',
      unexpectedEntry: 'Le champ « {{field}} » n\'est pas attendu pour ce paramètre.',
      invalidList: 'Le format attendu est une liste de valeurs.',
      invalidListItem: 'La liste ne doit contenir que des valeurs non vides.',
      invalidSecret: 'Le format attendu est une chaîne de caractères.',
      invalidString: 'Le format attendu est du texte.',
      invalidCron: 'Expression cron invalide. Format attendu : 5 ou 6 champs, par exemple « 0 30 4 * * * » pour 4 h 30 chaque jour.',
      stringTooShort: 'Cette valeur ne peut pas être vide.',
      stringTooLong: 'Cette valeur est trop longue.',
      invalidEmail: 'Adresse email invalide.',
      invalidHex: 'Une clé se saisit en hexadécimal : chiffres de 0 à 9, lettres de A à F, en nombre pair.',
      secretTooShort: 'Le secret saisi est trop court.',
      emptySecret: 'Saisir la nouvelle valeur, ou utiliser « Réinitialiser » pour abandonner la modification.',
      settingsEncryptionKeyMissing: "Aucune clé de chiffrement configurée : définir SETTINGS_ENCRYPTION_KEY côté serveur.",
      settingsEncryptionKeyUnknown: 'La valeur en base a été chiffrée avec une clé inconnue du serveur.',
      cipherAuthFailed: 'La valeur chiffrée en base est corrompue ou a été modifiée.',
      settingNotFound: "Ce paramètre n'existe pas en base.",
      historyEntryNotFound: "Cette entrée d'historique n'existe plus.",
      secretNotRestorable: "Un secret ne peut pas être restauré : sa valeur n'est pas conservée dans l'historique. Saisissez une nouvelle valeur.",
      noValueToRestore: "Cette entrée d'historique ne contient aucune valeur à restaurer.",
      historyLoad: 'Historique indisponible.',
      invalidJson: 'Le JSON saisi est invalide.',
      notAllow: 'Action réservée au superadmin.',
      notAuthentified: 'Session expirée, reconnectez-vous.',
      unknown: 'Une erreur est survenue.'
    }
  },
  alarms: {
    devicetype: {
      device: "Appareil",
      box: "Boitier"
    },
    filterlabel: "Types d'alarmes",
    statusfilterlabel: "Statut d'alarme",
    errorloading: "Les données n'ont pas pu être chargées.",
    title: "Alarmes",
    jointHousingGroup: {
      none: "Sélectionnez une copropriété"
    },
    housingGroup: {
      none: "Sélectionnez un bâtiment"
    },
    housing: {
      none: "Sélectionnez un logement"
    },
    nbalarm: "{{count}} alarmes",
    nbmeterreading_0: "Aucune alarme",
    nbmeterreading_1: "1 alarme",
    noalarm: "Aucune alarme",
    table: {
      date: "Date",
      jointhousinggroup: "Copropriété",
      housinggroup: "Bâtiment",
      housing: "Logement",
      lastmeterdate: "Dernier relevé",
      deviceuid: "Uid",
      devicetype: "Type de compteur",
      deviceserialradio: "N° radio",
      deviceserial: "N° de serie",
      nbday: "Durée",
      type: "Type",
      status: "Status",
      attributes: "Attributs",
      datereading: "Date de relevé",
      alarms: "Alarmes",
      tickets: "Tickets",
      consumption: "Consommation",
      absenceperiod: "Période d'absence",
      period: "Période",
      threshold: "Seuil"
    },
    setNew: "Marquer comme nouvelle",
    setOngoing: "Marquer comme en cours",
    setRead: "Marquer comme lues",
    setHidden: "Marquer comme cachées",
    createticket: "Créer un ticket",
    startAndEnd: 'Début : {{start}} - Fin : {{end}}',
    startAndEndAndAlarms: 'Début : {{start}} - Fin : {{end}} - Alarmes : {{alarms}}',
    startAndInProgress: 'Début : {{start}} - Fin : En cours',
    startAndInProgressAndAlarms: 'Début : {{start}} - Fin : En cours - Alarmes : {{alarms}}',
    emulateIndexes: "(forfaits générés)",
    emulateIndexesWithTotal: "(forfaits générés {{total}} m3)",
    shownew: "Nouvelles alarmes",
    showongoing: "Alarmes en cours",
    showread: "Alarmes lues",
    showhidden: "Alarmes cachées",
    types: {
      dailyMeter: "Relevé quotidien",
      waterLoss: "Perte d'eau",
      batteryCharge: "Charge batterie",
      headRemoved: "Tête Retirée",
      inverseFlow: "Flux Inversé",
      opticalFraud: "Fraude Optique",
      partialNoFlow: "Flux partiel",
      magneticFraud: "Fraude Magnétique",
      flowTooBig: "Flux trop élévé",
      radioRemovedFromMeter: "Tête radio Retirée",
      leakage: "Fuite",
      reverseFlowAboveThreshold: "Volume Flux Inversé dépassé",
      maxFlowRate: "Max Flux Dépassé",
      mountedWrongVerse: "Montage Inversé",
      noWaterConsumption: "Pas de Consommation",
      sensor1CableBroken: "Sonde Compteur Coupé",
      sensor1ShortCircuit: "Sonde Compteur Court-Circuit",
      sensor2CableBroken: "Sonde Coupé",
      sensor2ShortCircuit: "Sonde Coupé Court-Circuit",
      flowMeasurementSystem: "Erreur Mesure de Flux",
      electronicDefective: "Électronique Défectueux",
      reset: "Réinitialisé",
      lowBattery: "Pile Faible",
      outOfOperatingTemperature: "En dehors des températures recommandées",
      expiredSealingPeriod: "Date de scellement dépassée",
      metrologicalWrongChecksum: "Mémoire du programme corrompue.",
      negativeFlow: "Flux Négatif",
      absenceConsumption: "Consommation pendant absence",
      monthlyConsumptionThreshold: "Dépassement seuil mensuel",
      yearlyConsumptionThreshold: "Dépassement seuil annuel"
    }
  },
  negativeflow: {
    title: "Détection des Flux Négatifs",
    noaccess: "Vous n'avez pas accès à cette fonctionnalité.",
    errorloading: "Les données n'ont pas pu être chargées.",
    filters: {
      alljointhousinggroups: "Toutes les copropriétés",
      allhousinggroups: "Tous les bâtiments",
      allhousings: "Tous les logements",
      devicetype: "Type de compteur",
      alldevicetypes: "Tous les types",
      datestart: "Date début",
      dateend: "Date fin",
      minthreshold: "Seuil minimum (litres)"
    },
    search: "Rechercher",
    searching: "Recherche en cours...",
    updatealarms: "Mettre à jour les alarmes",
    updating: "Mise à jour en cours...",
    updateresult: "Alarmes : {{added}} ajoutées, {{updated}} mises à jour, {{deleted}} supprimées",
    nbresults: "{{count}} résultats",
    noresults: "Aucun flux négatif détecté",
    table: {
      jointhousinggroup: "Copropriété",
      housinggroup: "Bâtiment",
      housing: "Logement",
      devicetype: "Type",
      radionumber: "N° Radio",
      serialnumber: "N° Série",
      datereading: "Date relevé",
      index: "Index",
      previousindex: "Index précédent",
      negativeflow: "Flux négatif",
      hasalarm: "Alarme",
      yes: "Oui",
      no: "Non"
    }
  },
  ticket: {
    status_0: "Ouvert",
    status_1: "En cours",
    status_2: "Résolu",
    status_3: "Fermé",
    none: "Aucun ticket"
  },
  tickets: {
    title: "Tickets",
    add: "Ajouter un ticket",
    detail: "Ticket",
    info: "Infos",
    label: "Libellé",
    nbtickets: "{{count}} tickets",
    notickets: "Aucun ticket",
    titleCol: "Titre",
    description: "Description",
    noDescription: "Aucune description",
    createdAt: "Créé le",
    updatedAt: "Mis à jour le",
    status: "Statut",
    actionsCol: "Actions",
    lastAction: "Dernière action",
    alarms: "Alarmes",
    noAlarms: "Aucune alarme",
    noAlarm: "Sans alarme",
    alarmState: "État",
    alarmActive: "Active",
    alarmResolved: "Résolue",
    housings: "Logements",
    noHousings: "Aucun logement",
    addHousing: "Ajouter un logement",
    addAlarm: "Ajouter une alarme",
    selectJointHousingGroup: "Veuillez sélectionner une copropriété pour afficher les logements",
    action: "Action",
    owners: "Propriétaires",
    tenants: "Locataires",
    noActions: "Aucune action",
    addAction: "Ajouter une action",
    editAction: "Modifier une action",
    addActionType: "Ajouter {{article}} {{action}}",
    editActionType: "Modifier {{article}} {{action}}",
    confirmDeleteAction: "Êtes-vous sûr de vouloir supprimer cette action ?",
    actionType: "Type d'action",
    executedAt: "Date d'exécution",
    subject: "Sujet",
    body: "Corps",
    content: "Contenu",
    contactName: "Interlocuteur",
    phone: "Téléphone",
    comment: "Commentaire",
    saveAction: "Enregistrer",
    sendEmail: "Envoyer",
    saveWithoutSending: "Ajouter l'action sans envoi d'email",
    from: "De",
    to: "À",
    device: "Appareil",
    deviceType: "Type",
    type: "Type",
    export: "Exporter",
    exportDetail: "Enregistrer le xls",
    saveXls: "Enregistrer le xls",
    all: "Tous",
    fromDate: "Du",
    toDate: "Au",
    toSeparator: "au",
    alarmStatus: "Statut alarme",
    alarmType: "Type alarme",
    filterAllActions: "Toutes les actions",
    sortByExecutedAt: "Par date d'exécution",
    sortByCreatedAt: "Par date de création",
    sortByActionType: "Par type d'action",
    filterAllActions: "Toutes les actions",
    sortByExecutedAt: "Par date d'exécution",
    sortByCreatedAt: "Par date de création",
    sortByActionType: "Par type d'action",
    template: "Template",
    noTemplate: "Pas de template",
    selectRecipients: "Sélectionner",
    noRecipientsAvailable: "Aucun email de contact disponible",
    errors: {
      emailRequired: "Au moins un email valide est requis dans le champ \"À\"",
      invalidEmails: "Un ou plusieurs emails sont invalides",
      invalidEmail: "L'email est invalide",
      emailSendFailed: "Erreur lors de l'envoi de l'email"
    },
    jhg: "Copropriété",
    hg: "Bâtiment",
    housing: "Logement",
    serial: "N° de série",
    duration: "Durée",
    attributes: "Attributs",
    removeAlarm: "Retirer l'alarme",
    removeHousing: "Retirer le logement",
    confirmRemoveAlarm: "Êtes-vous sûr de vouloir retirer cette alarme du ticket ?",
    confirmRemoveHousing: "Êtes-vous sûr de vouloir retirer ce logement du ticket ?",
    cannotRemoveHousingFromAlarm: "Ce logement ne peut pas être retiré car il est lié à une alarme du ticket",
    errorRemoveAlarm: "Erreur lors de la suppression de l'alarme",
    errorRemoveHousing: "Erreur lors de la suppression du logement",
    emailForm: {
      title: "Envoyer un email",
      template: "Template",
      noTemplate: "Aucun",
      subject: "Sujet",
      body: "Corps",
      send: "Envoyer"
    },
    actions: {
      email: "Envoyer un email",
      emailReceived: "Email reçu",
      callOut: "Appel sortant",
      callIn: "Appel entrant",
      otherContact: "Autre contact",
      intervention: "Intervention",
      interventionReport: "Compte rendu d'intervention",
      comment: "Commentaire",
      resolve: "Résoudre le ticket",
      close: "Fermer le ticket",
      addHousing: "Ajout logement",
      removeHousing: "Suppression logement",
      addAlarm: "Ajout alarme",
      removeAlarm: "Suppression alarme",
      emailFields: {
        from: "De",
        to: "À"
      }
    },
    ticketClosed: "Le ticket est fermé"
  },
  emailtemplates: {
    title: "Templates d'email",
    titleLabel: "Titre",
    subject: "Sujet",
    body: "Corps",
    isDefault: "Favori par défaut",
    create: "Créer",
    update: "Mettre à jour",
    add: "Ajouter un template",
    edit: "Modifier un template",
    createdAt: "Créé le",
    updatedAt: "MAJ le",
    author: "Auteur",
    filter: "Filtrer :",
    filterAll: "Tous",
    filterPersonal: "Personnels",
    filterGeneric: "Génériques",
    noTemplates: "Aucun template",
    expand: "Développer",
    collapse: "Réduire",
    setDefault: "Définir comme favori",
    removeDefault: "Retirer le favori",
    empty: "-",
    signature: "Signature",
    signaturePlaceholder: "Texte de signature (optionnel)",
    uploadImage: "Ajouter une image",
    uploading: "Upload...",
    imageInfo: "(Max 2MB, JPEG/PNG/GIF/WebP)",
    removeImage: "Supprimer l'image",
    imageTooLarge: "L'image est trop grande (max 2MB)",
    invalidImageType: "Type d'image non supporté (JPEG, PNG, GIF, WebP uniquement)",
    uploadError: "Erreur lors de l'upload",
    imageValidationError: "Erreur de validation de l'image",
    fileName: "Fichier",
    current: "Actuel",
    limit: "Limite",
    allowed: "Formats autorisés",
    imageLimitsTitle: "Limites pour les images de signature :",
    sizeLimit: "Taille",
    dimensionsLimit: "Dimensions",
    formatsLimit: "Formats",
    quantityLimit: "Quantité",
    imageAlreadyAdded: "Une image est déjà présente. Supprimez-la d'abord.",
    removeDefault: "Retirer comme favori",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer ce template ?",
    userNumber: "User #{{number}}",
    empty: "-"
  },
  box: {
    battery: 'Batterie : ',
    gsm: 'Gsm : ',
    housinggroup: 'Bâtiment : ',
    iccid: 'Iccid : ',
    jointhousinggroup: 'Copropriété : ',
    lastmeterfile: 'Derniers relevé : ',
    lastsupervisionfile: 'Dernière supervision : ',
    location: 'Localisation : ',
    model: 'Modèle : ',
    serial: 'N° de série : ',
    signal: 'Signal : ',
    temperature: 'Température : ',
    uid: 'Uid : ',
  },
  boxes: {
    errorloading: 'Erreur de chargement des données',
    title: "Boitiers",
    jointHousingGroup: {
      none: "Sélectionnez une copropriété"
    },
    housingGroup: {
      none: "Sélectionnez un bâtiment"
    },
    nbboxes_other: '{{count}} boitiers',
    nbboxes_zero: 'Aucun boitier',
    nbboxes_one: '1 boitier',
    nobox: 'Aucun boitier trouvé'
  },
  boxset: {
    actions: {
      form: {
        actionplaceholder: "Choisir une action",
        datestart: "Date de début",
        dateend: "Date de fin",
        deleteindex: "Supprimer les relevés du boitier",
        execute: "Executer",
        readfileagain: "Relire les fichiers du boitier",
        deleteandreadfileagain: "Supprimer les relevés et relire les fichiers du boitier",
        duration: "Définir une durée"
      }
    },
    add: {
      title: "Ajouter un boitier"
    },
    deletebox: {
      confirm: {
        text: 'Supprimez ce boitier ?',
        validate: 'Supprimer'
      },
      error: "Le boitier n'a pas pu être supprimé. Veuillez réessayer.",
      label: "Supprimer le boitier"
    },
    edit: {
      title: "Modifier un boitier"
    },
    errorloading: 'Erreur de chargement des données',
    erroruploading: "Certaines images n'ont pas pu être téléchargées.",
    form: {
      datecreate: "Créé le ",
      deletephoto: {
        confirm: {
          text: 'Supprimez cette photo ?',
          validate: 'Supprimer'
        },
        error: "La photo n'a pas pu être supprimée. Veuillez réessayer.",
      },
      errornoright: "Vous n'avez pas les droits pour modifier ce boitier",
      errorunknown: "Le boitier n'a pas pu être enregistré. Veuillez réessayer.",
      gsm: {
        label: "Gsm"
      },
      housinggroup: {
        label: "Bâtiment",
        errorempty: "Un bâtiment doit être sélectionné.",
        none: "Sélectionnez un bâtiment"
      },
      iccid: {
        label: "Iccid"
      },
      jointhousinggroup: {
        label: "Copropriété",
        none: "Sélectionnez une copropriété"
      },
      location: {
        label: "Location"
      },
      model: {
        label: "Modèle"
      },
      photo: {
        label: "Photo"
      },
      serial: {
        label: "Numéro de série",
        errorempty: "Un numéro de série doit être renseigné.",
        serialalreadyexist: "Cet numéro de série est déjà utilisé par un autre boitier actif."
      },
      status: {
        label: "Status"
      },
      uid: {
        label: "Uid",
        errorempty: "Un uid doit être renseigné.",
        uidalreadyexist: "Cet uid est déjà utilisé par un autre boitier actif."
      },
      validate: "Enregistrer"
    },
    parameter: {
      alarm: {
        add: "Ajouter une désactivation d'alarme",
        remove: "Supprimer une désactivation d'alarme",
        label: "Désactivation des alarmes",
        typeDefault: "Sélectionner un type"
      },
      validate: "Enregistrer"
    },
    tab: {
      action: "Actions",
      box: "Boitier",
      history: "Historique",
      parameter: "Paramètres",
      supervision: "Supervision"
    },
    supervisionreadingform: {
      addsupervisionreading: "Ajouter un relevé de supervision",
      datereading: "Date",
      index_sw: "Version",
      index_temp: "Température",
      index_batCap: "Batterie (V)",
      index_nwMode: "Mode réseau",
      index_signal: "Signal",
      index_batPrcent: "Batterie (%)",
      index_nwOperator: "Opérateur",
      validate: "Enregistrer"
    },
    nbsupervisionreading_other: '{{count}} relevés',
    nbsupervisionreading_zero: 'Aucun relevé',
    nbsupervisionreading_one: '1 relevé',
  },
  confirm: {
    error: "La vérification n'a pas pu aboutir. Merci de réessayer.",
    text: "Vérification en cours ..."
  },
  consumptioncard: {
    current: "Actuel",
    error: "Erreur lors du chargement des données",
    loading: "Chargement en cours",
    no_data: "Données insuffisantes",
    noenoughtdata: "Données insuffisantes",
    previous: "Précédent",
    previous_no_data_tooltip: "Données insuffisantes pour comparer la consommation avec l'année précédente",
    previous_tooltip: "Même période de l'année précédente",
    type10: "Consommation eau chaude depuis janvier",
    type20: "Consommation eau froide depuis janvier",
    type30: "Consommation chauffage depuis janvier"
  },
  deviceimport: {
    errorunknown: "Les données n'ont pas pu être chargées dans leur intégralité. Veuillez réessayer.",
    erroranalysing: "Les données n'ont pas pu être chargées.",
    title: 'Importer des appareils',
    form: {
      errorlist: {
        elttype_device: 'Appareil',
        elttype_housing: 'Logement',
        elttype_housingGroup: 'Bâtiment',
        elttype_meterReading: 'Relevé',
        errortype: 'Erreur inconnue',
        errortype_addressEmpty: 'Adresse non renseignée',
        errortype_postalcodeEmpty: 'Code postal non renseigné',
        errortype_cityEmpty: 'Ville non renseignée',
        errortype_apartmentDetailsEmpty:
          'Informations logement non renseignées',
        errortype_typeEmpty: 'Type non renseigné',
        errortype_serialEmpty:
          'Numéro de serie ou de module radio non renseigné',
        errortype_statusEmpty: 'Status non renseignée',
        errortype_dateReadingMeterReadingEmpty: '',
        errortype_indexvalueMeterReadingEmpty: '',
        elttypelabel: 'Type de donnée',
        linelabel: 'Ligne',
        sheetlabel: 'Feuille',
      },
      file: 'Charger un fichier',
    },
    sample: {
      label: "Voici un exemple de fichier à importer, complétez le avec vos données :",
      link: "Cliquez ici pour télécharger ce fichier",
      ediLabel: "Voici un exemple de fichier à importer à partir d'identifiants EDI, complétez le avec vos données :",
      ediLink: "Cliquez ici pour télécharger ce fichier",
      sheet: {
        ec: {
          label: "Relevé EC"
        },
        ef: {
          label: "Relevé EF"
        },
        c: {
          label: "Relevé C"
        }
      }
    },
    uploadlist: {
      errorDateReading: "Date incorrecte",
      header: {
        address: "Adresse",
        apartmentNumber: "Appartement",
        batch: "Lot",
        batchtype: "Type",
        city: "Ville",
        country: "Pays",
        date_reading: "Date lecture",
        email: "Email propriétaire",
        phone: "Téléphone propriétaire",
        floor: "Etage",
        index_values: "Valeur",
        line: "Ligne",
        label: "Intitulé",
        lastname: "Nom",
        loc_email: "Email locataire",
        loc_phone: "Téléphone locataire",
        loc_lastname: "Nom locataire",
        location: "Emplacement",
        origin: "Origine",
        postal_code: "Code postal",
        serial: "N° compteur",
        serialRadio: "N° module radio",
        serialOther: "N° sonde 1",
        serialOther2: "N° sonde 2",
        sheet: "Feuille",
        status: "Status",
        type: "Type"
      },
      linestatus: {
        error: "Ces données contiennent des erreurs.",
        modified: "Ces données existent déjà et certaines ont été modifiées",
        multiHousing: "Ce compteur est déjà utilisé dans un autre logement",
        multiSerial: "Ce numéro de compteur est déjà utilisé par un autre de vos appareils",
        multiSerialNoAccess: "Ce numéro de compteur est déjà utilisé par un appareil d'un autre administrateur. Veuillez vérifier ce numéro et la cas échéant, contacter le superadministrateur.",
        multiSerialInSheet: "Ce numéro de compteur est importé plusieurs fois dans le fichier",
        new: "Ces données sont nouvelles",
        notmodified: "Ces données existent déjà et n'ont pas été modifiées",
        serialRadioTooShort: "Le numéro de série radio contient moins de 8 caractères",
        serialTooShort: "Le numéro de compteur contient moins de 8 caractères",
        serialOtherTooShort: "Le numéro sonde 1 contient moins de 8 caractères",
        serialOther2TooShort: "Le numéro sonde 2 contient moins de 8 caractères"
      },
      nohousinggroup: "Aucun bâtiment",
      nohousing: "Aucun logement",
      nodevice: "Aucun appareil",
      nometerreading: "Aucun relevé",
      lowerThenPreviousFromDb: "Relevé plus bas que le précedent trouvé dans la base de donnée",
      lowerThenPreviousFromSheet: "Relevé plus bas que le suivant trouvé sur le fichier",
      upperThenNextFromDb: "Relevé plus haut que le suivant trouvé dans la base de donnée",
      upperThenNextFromSheet: "Relevé plus haut que le suivant trouvé sur le fichier",
      tab: {
        analyseinprogress: "Analyse en cours ...",
        importinprogress: "Import en cours ...",
        housinggroup: "{{nb}} bâtiment",
        housinggroup_plurial: "{{nb}} bâtiments",
        housing: "{{nb}} logement",
        housing_plurial: "{{nb}} logements",
        device: "{{nb}} appareil",
        device_plurial: "{{nb}} appareils",
        meterreading: "{{nb}} indexe",
        meterreading_plurial: "{{nb}} indexes"
      },
      validate: 'Importer',
      validateConfirm: {
        serialTooShort: "{{count}} appareil(s) ont un ou plusieurs numéros de série de moins de 8 caractères. Voulez-vous continuer malgré tout ?",
        confirm: 'Confirmer'
      }
    }
  },
  devices: {
    errorloading: 'Erreur de chargement des données',
    housing: {
      none: 'Sélectionnez un logement',
    },
    housingGroup: {
      none: 'Sélectionnez un bâtiment',
    },
    jointHousingGroup: {
      none: 'Sélectionnez une copropriété',
    },
    nbdevice_other: '{{count}} appareils',
    nbdevice_zero: 'Aucun appareil',
    nbdevice_one: '1 appareil',
    nodevice: 'Aucun appareil trouvé',
    table: {
      jointhousinggroup: 'Copropriété',
      housing: 'N° de logement',
      serial: 'N° de série radio',
      type: 'Type',
      status: 'Status',
      lastmeterreadingdate: 'Date du dernier relevé',
      signal: 'Signal'
    },
    title: 'Les appareils',
    type: {
      none: 'Sélectionnez un type',
    },
    savexls: "Enregistrer le xls",
    status: {
      none: 'Sélectionnez un status',
    },
    xls: {
      sheetlabel: "Appareils"
    }
  },
  deviceset: {
    adddevicelog: {
      add: 'Ajouter',
      devicereference: 'Appareil de référence',
      comment: 'Commentaire',
      date: 'Date',
      datestart: 'Date de début',
      dateend: 'Date de fin',
      emulateindexes: 'Créer un forfait de consommation',
      logtype: {
        commissioning: 'Mise en service',
        headchanging: 'Changement de tête',
        outofservice: 'Mise hors service',
        deviceblocked: 'Appareil bloqué',
        replacement: 'Remplacement d\'appareil',
        alarm: 'Alarme',
        noalarm: 'Fin alarme',
        other: 'Autre',
        emailSent: 'Mail envoyé',
        10: "Relevé manquant",
        11: "Flux inversé",
        12: "Flux partiel",
        13: "Flux négatif",
        // 14/15/16 manquaient : ces alarmes n'atterrissaient dans l'historique que par
        // `checkRemoveAlarmsOfDeviceNotInFunction`, qui y recopie le type quel qu'il soit —
        // la colonne affichait alors la clé brute. Les afficher en cours (#303) rendait la
        // lacune quotidienne. Libellés repris de `alarms.types`, pour dire la même chose au
        // même endroit.
        14: "Consommation pendant absence",
        15: "Dépassement seuil mensuel",
        16: "Dépassement seuil annuel",
        20: "Alarme appareil",
        30: "Relevé manquant"
      },
      emailReason: {
        consumptionThreshold: "Dépassement de seuil de consommation",
        absenceConsumption: "Consommation pendant absence"
      },
      replacementserial: 'Numéro de compteur de remplacement',
      replacementserialplaceholder: 'Saisir le numéro de compteur',
      replacementlabel: 'Remplacé par appareil N°',
      submit: 'Enregistrer',
      type: 'Type',
      wrongtypevalue: "Le type n'est pas valide.",
      wrongdate: "La date est obligatoire.",
      wrongreplacementserial: "Le numéro de compteur de remplacement est obligatoire.",
      unknownerror: "L'historique' n'a pu être ajouté. Veuillez réessayer.",
    },
    addmeterreading: {
      submit: 'Enregistrer',
      unknownerror: "Le relevé n'a pu être ajouter. Veuillez réessayer.",
      wrongindexvalue: "La valeur de l'indexe n'est pas valide.",
      wrongdate: "La date de relevé n'est pas valide.",
      ignoredhigherindex: "Le relevé n'a pas été pris en compte : un seul relevé est conservé par jour, et celui déjà enregistré ce jour-là affiche un index au moins aussi élevé.",
    },
    addtitle: 'Ajouter un appareil',
    deletemeterreading: {
      confirm: {
        text: 'Supprimez ce relevé ?',
        validate: 'Supprimer',
      },
      error: 'La suppression a échoué. Veuillez réessayez.',
    },
    deviceform: {
      datecreate: 'Créé le',
      errorunknown: "Une erreur s'est produite. Veuillez réessayer.",
      housing: {
        errorempty: 'Un logement doit être sélectionné.',
        label: 'Logement',
        new: 'Nouveau logement',
        placeholder: 'Sélectionnez un logement',
      },
      location: {
        label: "Emplacement"
      },
      serial: {
        errorempty: 'Le numero de série ou le numéro de série du module radio doit être renseigné.',
        erroralreadyexists: 'Ce numéro de compteur est déjà utilisé par un autre appareil',
        errorlength: 'Le numéro de compteur doit contenir au minimum 8 caractères. Voulez-vous continuer malgré tout ?',
        confirm: 'Confirmer',
        label: 'Numéro compteur',
      },
      serialRadio: {
        erroralreadyexists: 'Ce numéro de module radio est déjà utilisé par un autre appareil',
        errorlength: 'Le numéro de série radio doit contenir au minimum 8 caractères. Voulez-vous continuer malgré tout ?',
        confirm: 'Confirmer',
        label: 'Numéro module radio',
      },
      serialOther: {
        erroralreadyexists: 'Ce numéro de série sonde 1 est déjà utilisé par un autre appareil',
        errorlength: 'Le numéro sonde 1 doit contenir au minimum 8 caractères. Voulez-vous continuer malgré tout ?',
        confirm: 'Confirmer',
        label: 'Numéro sonde 1 (autre)',
      },
      serialOther2: {
        erroralreadyexists: 'Ce numéro de série sonde 2 est déjà utilisé par un autre appareil',
        errorlength: 'Le numéro sonde 2 doit contenir au minimum 8 caractères. Voulez-vous continuer malgré tout ?',
        confirm: 'Confirmer',
        label: 'Numéro sonde 2 (autre)',
      },
      status: {
        label: 'status',
      },
      title: 'Ajouter un appareil',
      edittitle: 'Modifier un appareil',
      addtitle: 'Ajouter un appareil',
      remove: 'Supprimer',
      type: {
        errorempty: 'Le type du module radio doit être renseigné.',
        label: 'Type',
        placeholder: 'Sélectionnez un type',
      },
      validate: 'Enregistrer',
      validation: {
        shortFields: 'Les champs suivants ne respectent pas leur longueur minimale requise :\n\n{{fields}}\n\nVoulez-vous continuer malgré tout ?',
        confirm: 'Confirmer',
      },
    },
    edittitle: 'Modifier un appareil',
    errorloading: 'Erreur de chargement des données',
    logedit: "Modifier",
    meterreadingform: {
      addmeterreading: 'Ajouter un relevé',
      datereading: 'Date de relevé',
      index_vol: 'Volume',
      index_energy: "Conso énergie",
      index_volume: "Volume total",
      index_curFlow: "Débit",
      index_curPower: "Valeur courant",
      index_forwardTemp: "Temp départ",
      index_backTemp: "Temp retour",
      index_diffTemp: "Diff. temp",
      origin: "Origine",
      showframe: "Voir le fichier de trames d'origine",
      validate: 'Enregistrer',
    },
    nbdevicelog_other: '{{count}} logs',
    nbdevicelog_zero: 'Aucun log',
    nbdevicelog_one: '1 log',
    nbmeterreading_other: '{{count}} relevés',
    nbmeterreading_zero: 'Aucun relevé',
    nbmeterreading_one: '1 relevé',
    parameter: {
      alarm: {
        add: "Ajouter une désactivation d'alarme",
        description: {
          placeholder: "Description"
        },
        remove: "Supprimer une désactivation d'alarme",
        label: "Désactivation des alarmes",
        typeDefault: "Sélectionner un type"
      },
      validate: "Enregistrer"
    },
    removeDevicelog: {
      unknownerror: "L'historique' n'a pu être supprimé. Veuillez réessayer."
    },
    tab: {
      device: 'Appareil',
      history: 'Historique',
      meterreadings: 'Relevés',
      parameter: 'Paramètres',
      hourlyreadings: 'Historique horaire'
    },
    hourlyreadings: {
      errorloading: "Les relevés horaires n'ont pas pu être chargés.",
      nodata: "Aucun relevé horaire disponible pour cet appareil.",
      noreadings: "Aucun relevé trouvé pour la période sélectionnée.",
      startdate: "Date de début",
      enddate: "Date de fin",
      selectstartdate: "Sélectionner une date de début",
      selectenddate: "Sélectionner une date de fin",
      resetfilters: "Réinitialiser",
      exportcsv: "Exporter en CSV",
      timestamp: "Date et heure",
      volume: "Volume (l)",
      deltavolume: "Delta volume (l)",
      totalreadings: "{{count}} relevé(s) affiché(s)",
      nbreadings: "{{count}} relevé(s) horaire(s)"
    },
  },
  edi: {
    id: "Identifiant EDI",
    presta_id: "ID Prestataire EDI",
    last_point: "Dernier n° de point",
    point_number: "N° de point EDI",
    coef_radiator: "Coefficient radiateur EDI",
    coef_housing: "Coefficient logement EDI",
    dates: "Périodes comptables EDI",
    dates_start: "Début",
    dates_end: "Fin",
    actions: {
      title: "Actions EDI",
      export_lgr: "Exporter LGR",
      import_pc: "Importer périodes comptables (PC)",
      importing: "Import en cours...",
      export_repart: "Exporter REPART..."
    },
    export: {
      noediid: "Cette copropriété n'a pas d'identifiant EDI.",
      nodata: "Aucune donnée à exporter.",
      error: "Erreur lors de l'export.",
      selectPresta: "Sélectionner le gestionnaire",
      noPresta: "Aucun gestionnaire trouvé",
      enterPresta: "Aucun gestionnaire avec un identifiant prestataire EDI n'a accès à cette copropriété. Veuillez saisir l'identifiant manuellement."
    },
    import_pc: {
      success: "{{count}} période(s) comptable(s) importée(s).",
      nodata: "Aucune période comptable trouvée dans le fichier.",
      error: "Erreur lors de l'import des périodes comptables."
    }
  },
  ediimport: {
    title: "Importer un fichier EDI (LGE)",
    form: {
      file: "Charger un fichier",
      description: "Sélectionnez un fichier CSV au format EDI LGE pour importer les résidences, bâtiments, logements et occupants."
    },
    analysing: "Analyse du fichier en cours...",
    importing: "Importation en cours...",
    preview: {
      file: "Fichier"
    },
    import: "Importer",
    done: "Importation terminée",
    newimport: "Nouvel import",
    results: {
      jhg: "{{count}} copropriété(s) créée(s)",
      hg: "{{count}} bâtiment(s) créé(s)",
      housing: "{{count}} logement(s) créé(s)",
      contact: "{{count}} contact(s) créé(s)"
    },
    tab: {
      jhg: "Copropriétés",
      hg: "Bâtiments",
      housing: "Logements",
      contact: "Occupants"
    },
    col: {
      status: "Statut",
      label: "Libellé",
      address: "Adresse",
      city: "Ville",
      apartment: "Logement",
      housing: "Logement",
      name: "Nom",
      ref: "Référence",
      date: "Date d'entrée"
    },
    status: {
      new: "Nouveau",
      existing: "Existant"
    },
    usergroup: "Gestionnaire",
    selectUserGroup: "Sélectionner le gestionnaire",
    searchUserGroup: "Rechercher un gestionnaire...",
    noUserGroup: "Aucun gestionnaire trouvé"
  },
  documents: {
    download: {
      error: "Le téléchargement a échoué. Veuillez réessayez.",
    }
    , remove: {
      confirm: {
        text: "Supprimer ce document ?",
        validate: "Supprimer"
      },
      error: "La suppression a échoué. Veuillez réessayez.",
      label: "Supprimer le document"
    }
    , title: "Documents"
    , add: "Ajouter un document"
    , nodocument: "Aucun document"
    , load: {
      error: "Les données n'ont pas pu être chargées."
    }
    , table: {
      delete: "Supprimer"
      , edit: "Modifier"
      , label: "Fichier"
      , description: "Description"
      , range: "Période"
      , date: "Date d'ajout"
      , status: "Status"
      , type: "type"
    }
  },
  documentset: {
    errorloading: "Les données n'ont pas pu être chargées.",
    erroruploading: "Le document n'a pas pu être téléchargé.",
    errormodifying: "Le document n'a pas pu être modifié.",
    form: {
      date: {
        title: "Date de dépose"
      },
      enddate: {
        title: "Date de fin"
      },
      description: {
        title: "Description"
      },
      file: {
        title: "Fichier"
      },
      startdate: {
        title: "Date de début"
      },
      type: {
        title: "Type de document"
      },
      validate_add: 'Ajouter',
      validate_modify: 'Modifier'
    },
    title_add: 'Ajouter un document',
    title_modify: 'Modifier un document'
  },
  forgot: {
    done: {
      text: "Vous allez recevoir un email avec un lien pour réinitialiser votre mot de passe."
    },
    form: {
      error_loginEmpty: "L'identifiant' doit être renseigné",
      error_userNotFound: "Ce compte n'existe pas.",
      error_waitToSendNewEmail: "Vous devez attendre avant de faire une nouvelle demande.",
      error_noEmail: "L'email de ce compte n'a pas été renseigné. Nous ne pouvons vous envoyer un nouveau mot de passe, veuillez contacter le support.",
      error_userNotActivated: "Ce compte n'a pas été activé. Veuillez utiliser la clé qui vous a été fournie pour créer le compte.",
      error_userDesactivated: "Ce compte n'a pas été désactivé. Veuillez contacter le support.",
      error: "Une erreur s'est produite. Veuillez réessayer.",
      text: "Veuillez entrer votre indentifiant de compte pour recevoir un nouveau mot de passe.",
      validate: "Envoyer"
    },
    title: "Récupérer votre mot de passe"
  },
  ftpfiles: {
    boxlist: {
      none: "Sélectionnez un boitier"
    },
    details: {
      rowdata: "Trame originale complète :",
      frame: "Trame originale (partie données) :",
      framedecrypted: "Trame décryptée (partie données) :",
      alarms: "Alarmes",
      ftpstructure: "Structure FTP complète (LoRa uniquement) :"
    },
    errorloading: "Les données n'ont pas pu être chargées.",
    filemissing: "Ce fichier n'est plus disponible sur le serveur ftp : les fichiers de trames n'y sont conservés qu'un temps. Le relevé, lui, reste en base.",
    download: "Télécharger le fichier",
    filelist: {
      none: "Sélectionnez un fichier"
    },
    savexls: "Enregistrer le xls",
    import: "Importer ces télérelevés",
    importing: "Import en cours...",
    meterreadings: "relevés",
    // `error` était déclaré deux fois dans ce bloc : la seconde occurrence écrasait la
    // première, et `ftpfiles.error.download` n'existait donc plus — le popup d'échec de
    // téléchargement affichait la clé brute. Les deux jeux de clés sont ici fusionnés.
    error: {
      download: "Erreur lors du téléchargement du fichier.",
      nofileselected: "Aucun fichier sélectionné",
      import: "Erreur lors de l'import",
      alreadyrunning: "Un import de cet accès est déjà en cours. Attendez qu'il se termine : deux imports simultanés créeraient des doublons."
    },
    success: {
      import: "Import réussi"
    },
    table: {
      alarms: "Alarmes",
      details: "Voir les détails",
      jointhousinggroup: "Copropriété",
      housinggroup: "Bâtiment",
      housing: "Logement",
      devicetype: "Type",
      deviceserial: "N° compteur",
      deviceserialradio: "N° module radio",
      deviceserialother: "N° sonde 1",
      deviceserialother2: "N° sonde 2",
      datereading: "Date de lecture",
      indexvalues: "Indexe",
      signal: "Signal"
    },
    title: "Fichiers ftp",
  },
  ftpframe: {
    title: "Trames d'origine du relevé",
    notfound: "Le fichier de trames de ce relevé n'a pas été retrouvé.",
    searched: "Boitier recherché : {{uid}} — horodatage de la trame : {{ts}}. Le fichier a peut-être été purgé du serveur ftp, ou ce relevé ne provient pas d'un télérelevé.",
  },
  global: {
    alarm: {
      status_0: "Nouveau",
      status_1: "En cours",
      status_10: "Vu",
      status_20: "Caché",
      type_10: "Relevé quotidien",
      type_11: "Flux inversé",
      type_12: "Flux partiel",
      type_13: "Flux négatif",
      type_14: "Consommation pendant absence",
      type_15: "Dépassement seuil mensuel",
      type_16: "Dépassement seuil annuel",
      type_20: "Alarme appareil",
      type_30: "Relevé quotidien"
    },
    alarmflow: {
      qty_other: '{{count}} litres',
      qty_zero: '0 litre',
      qty_one: '1 litre'
    },
    alarmtime: {
      nbday_other: '{{count}} jours',
      nbday_one: "1 jour"
    },
    ticket: {
      status_0: "Ouvert",
      status_1: "En cours",
      status_2: "Résolu",
      status_3: "Fermé",
      none: "Aucun ticket"
    },
    add: 'Ajouter',
    back: 'Retour',
    cancel: 'Annuler',
    close: 'Fermer',
    validate: 'Valider',
    accessStatus: {
      active: 'Actif',
      revoked: 'Révoqué',
    },
    boxStatus: {
      inWaiting: 'En attente',
      inFunction: 'En fonction',
      outOfFucntion: 'Hors fonction',
      boken: 'Cassé',
    },
    deviceStatus: {
      inWaiting: 'En attente',
      inFunction: 'En fonction',
      outOfFucntion: 'Hors fonction',
      boken: 'Cassé',
    },
    deviceType: {
      coldWater: 'Eau froide',
      heater: 'Chauffage',
      hotWater: 'Eau chaude',
      water: 'Eau',
    },
    documentStatus: {
      active: 'Actif',
      revoked: 'Révoqué',
    },
    documentType: {
      contract: 'Contrat',
      mail: 'Courrier',
      invoice: 'Facture'
    },
    monthlabel1: 'janvier',
    monthlabel2: 'février',
    monthlabel3: 'mars',
    monthlabel4: 'avril',
    monthlabel5: 'mai',
    monthlabel6: 'juin',
    monthlabel7: 'juillet',
    monthlabel8: 'août',
    monthlabel9: 'septembre',
    monthlabel10: 'octobre',
    monthlabel11: 'novembre',
    monthlabel12: 'décembre',
    ok: 'Ok',
    previouspage: 'Page précédente',
    remove: "Supprimer",
    edit: "Modifier",
    delete: "Supprimer",
    error: "Erreur",
    siteName: 'CONSUMPTION',
    sitePoweredBy: 'by Compteurs & compagnie',
    siteUrl: 'https://compteursetcompagnie.fr/',
    tabdevicetype: {
      box: 'Boitier',
      heater: 'Chauffage',
      water: 'Eau',
    },
    tabview: {
      graph: 'Vue graphique',
      table: 'Vue tableau',
    },
    time: 'Heure',
    timeview: {
      hour: "Consommation horaire",
      day: 'Consommation journalière',
      month: 'Consommation mensuelle',
      year: 'Consommation annuelle',
    },
    unity_10: 'm3',
    unity_20: 'm3',
    unity_30: 'kw/h',
    userstatus: "Statut inconnu",
    userstatus_0: "Non activé",
    userstatus_1: "Email non confirmé",
    userstatus_10: "Actif",
    userstatus_11: "Réinitialisation du mot de passe",
    userstatus_90: "Suspendu",
    userstatus_99: "Compte supprimé",
    usertype_0: "Super administrateur",
    usertype_10: "Administrateur",
    usertype_20: "Gestionnaire administrateur",
    usertype_21: "Gestionnaire utilisateur",
    usertype_30: "Technicien administrateur",
    usertype_31: "Technicien utilisateur",
    usertype_40: "Utilisateur",
    valueStatus: {
      auto: 'Télérelevé',
      manual: 'Entrée manuelle',
    },
  },
  graph: {
    showpreviousyear: "Afficher l'année précédente"
  },
  graphmini: {
    heater: {
      title: "Total Résidence - Chauffage"
    },
    periodn: "PERIODE",
    periodnminus1: "PERIODE N-1",
    sanitary: {
      title: "Total Résidence - Sanitaire"
    }
  },
  home: {
    reader: {
      hello: 'Bonjour, {{name}} !',
      myresidence: 'Ma Résidence :',
      nohousing: "Aucun logement n'est associé à votre compte. Contactez votre gestionnaire pour configurer vos accès.",
      nodevice: "Aucun compteur n'est associé à votre logement. Contactez votre gestionnaire.",
      title: 'Mes consommations',
      tooltip: "Vos consommations cumulées du dernier mois relevé, comparées au même mois de l'année précédente (quand disponible). L'éco-score situe votre consommation par rapport à la moyenne des logements de votre copropriété pour ce même mois.",
      referencemonth: 'Consommation de {{month}}',
      hotwater: 'Eau chaude',
      coldwater: 'Eau froide',
      heater: 'Chauffage',
      comparison: {
        vspreviousyear_decreased: 'Votre consommation a baissé de {{percent}}% par rapport à {{month}} ({{value}} {{unit}})',
        vspreviousyear_increased: 'Votre consommation a augmenté de {{percent}}% par rapport à {{month}} ({{value}} {{unit}})',
        vspreviousyear_stable: 'Votre consommation est stable par rapport à {{month}} ({{value}} {{unit}})',
        unavailable: "Pas de comparaison disponible (1ère année)",
        nodata: 'Aucun relevé disponible pour le moment'
      },
      ecoscore: {
        excellent: 'Excellent',
        good: 'Bon',
        average: 'Moyen',
        high: 'Élevé',
        veryhigh: 'Très élevé',
        desc_below: 'Votre consommation est inférieure à la moyenne de votre copropriété',
        desc_within: 'Votre consommation est dans la moyenne de votre copropriété',
        desc_above: 'Votre consommation est supérieure à la moyenne de votre copropriété',
        unavailable: 'Comparaison non disponible'
      },
      detail: {
        label: 'Envie d\'en savoir plus ?',
        link_coldwater: 'Voir le détail de ma consommation d\'eau froide',
        link_hotwater: 'Voir le détail de ma consommation d\'eau chaude',
        link_heater: 'Voir le détail de ma consommation de chauffage',
        back: 'Retour à mes consommations',
        error: 'Impossible de charger le détail de la consommation',
        title_coldwater: 'Ma consommation d\'eau froide',
        title_hotwater: 'Ma consommation d\'eau chaude',
        title_heater: 'Ma consommation de chauffage',
        meters: 'Mes compteurs',
        nometer: 'Aucun compteur de ce type associé à votre logement',
        lastreading: 'Dernier relevé le {{date}}',
        viewreadings: 'Voir les relevés',
        graphtitle: 'Évolution de ma consommation'
      },
      synthesis: {
        title: 'Mon bilan',
        link: 'Voir mon bilan et mes graphiques',
        from: 'Du',
        to: 'au',
        serial: 'N° de série',
        location: 'Emplacement',
        startindex: 'Index début',
        endindex: 'Index fin',
        consumption: 'Consommation',
        total: 'Total',
        graph_water: 'Évolution de ma consommation d\'eau',
        graph_heater: 'Évolution de ma consommation de chauffage',
        error: 'Impossible de charger le bilan',
      },
      meter: {
        back: 'Retour au détail',
        error: 'Impossible de charger les relevés de ce compteur',
        title: 'Relevés du compteur {{serial}}',
        count_one: '{{count}} relevé',
        count_other: '{{count}} relevés',
        noreading: 'Aucun relevé disponible pour ce compteur',
        date: 'Date',
        index: 'Index'
      }
    },
    public: {
      text1:
        "Consumption est un outil de suivi d'indexe d'eau et de gaz. Il permet de consulter en temps réel votre consommation",
      text2: 'Consumption vous alerter en cas de consommation anormale.',
      text3:
        "Pour créer un compte et utiliser ce service, vous devez posséder une clé d'accès fournie par votre syndicat ou votre installateur.",
    },
    superadmin: {
      admins: {
        errorloading: "Les données n'ont pas pu être chargées.",
        nbadmin_other: '{{count}} administrateurs',
        nbadmin_zero: 'Aucun administrateur',
        nbadmin_one: '1 administrateur',
        nbsecretkey_other: '{{count}} clés en attente',
        nbsecretkey_zero: 'Aucune clé en attente',
        nbsecretkey_one: '1 clé en attente',
        title: 'Administrateurs',
      },
      buildingmanagers: {
        errorloading: "Les données n'ont pas pu être chargées.",
        nbmanager_other: '{{count}} gestionnaires',
        nbmanager_zero: 'Aucun gestionnaire',
        nbmanager_one: '1 gestionnaire',
        title: 'Gestionnaires',
      },
      // technicals: {
      //   errorloading: "Les données n'ont pas pu être chargées.",
      //   nbtechnical: '{{count}} techniciens',
      //   nbtechnical_0: 'Aucun technicien',
      //   nbtechnical_1: '1 technicien',
      //   title: 'Techniciens',
      // },
      users: {
        errorloading: "Les données n'ont pas pu être chargées.",
        nbuser_other: '{{count}} utilisateurs',
        nbuser_zero: 'Aucun utilisateur',
        nbuser_one: '1 utilisateur',
        title: 'Utilisateurs',
      },
      // , devices : {
      // 	errorloading : "Les données n'ont pas pu être chargées."
      // 	, nbdevice : "{{count}} appareils"
      // 	, nbdevice_0 : "Aucun appareil"
      // 	, nbdevice_1 : "1 appareil"
      // 	, title : "Appareils"
      // }
      housings: {
        errorloading: "Les données n'ont pas pu être chargées.",
        import: 'Importer un fichier de données',
        nbdevice_other: '{{count}} appareils',
        nbdevice_zero: 'Aucun appareil',
        nbdevice_one: '1 appareil',
        nbhousing_other: '{{count}} logements',
        nbhousing_zero: 'Aucun logement',
        nbhousing_one: '1 logement',
        nbhousinggroup_other: '{{count}} bâtiments',
        nbhousinggroup_zero: 'Aucun bâtiment',
        nbhousinggroup_one: '1 bâtiment',
        nbjointhousinggroup_other: '{{count}} copropriétés',
        nbjointhousinggroup_zero: 'Aucune copropriété',
        nbjointhousinggroup_one: '1 copropriété',
        title: 'Logements',
        syncautometer: {
          label: 'Importer les télérelevés',
          inprogress: 'Import en cours ...',
          result: '{{count}} nouvelle valeur importée',
          result_plural: '{{count}} nouvelles valeurs importées',
        },
        updatealarm: {
          label: "Mettre à jour les alarmes",
          result: '{{count}} alarme trouvée',
          result_plural: '{{count}} alarmes trouvées',
        },
        viewalarms: "Voir les alarmes",
        viewftpfile: "Voir les fichiers ftp",
        viewmeters: "Voir les relevés"
      },
    },
  },
  housing: {
    deletedevice: {
      confirm: {
        text: 'Supprimez cet appareil ?',
        validate: 'Supprimer',
      },
      error: 'La suppression a échoué. Veuillez réessayez.',
      label: "Supprimer l'appareil'",
    },
    deletehousing: {
      confirm: {
        text: 'Supprimez ce logement ?',
        validate: 'Supprimer',
      },
      error: 'La suppression a échoué. Veuillez réessayez.',
      label: 'Supprimer le logement',
    },
    details: {
      apartnumber: 'N° : ',
      batch: 'Lot : ',
      batchtype: 'Type de lot : ',
      floor: 'Etage : ',
      housinggroup: 'Bâtiment : ',
      jointhousinggroup: 'Copropriété : ',
      owner: 'Propriétaire : ',
      ownerEmail: 'Email propriétaire : ',
      tenant: 'Locataire : ',
      tenantEmail: 'Email locataire : ',
    },
    device: {
      noMeter: 'Aucun relevé',
      hourlyReadings: 'Relevés horaires disponibles',
      serial: 'N° de série :',
      serialRadio: 'N° de série radio :',
      status: 'Status : ',
      type: 'type : ',
    },
    deviceform: {
      datecreate: 'Créé le',
      errorunknown: "Une erreur s'est produite. Veuillez réessayer.",
      housing: {
        errorempty: 'Un logement doit être sélectionné.',
        label: 'Logement',
        new: 'Nouveau logement',
        placeholder: 'Sélectionnez un logement',
      },
      serial: {
        errorempty:
          'Le numero de série ou le numéro de série du module radio doit être renseigné.',
        label: 'Numéro de série',
      },
      serialRadio: {
        label: 'Numéro de série du module radio',
      },
      status: {
        label: 'status',
      },
      title: 'Ajouter un appareil',
      edittitle: 'Modifier un appareil',
      addtitle: 'Ajouter un appareil',
      type: {
        errorempty: 'Le type du module radio doit être renseigné.',
        label: 'Type',
        placeholder: 'Sélectionnez un type',
      },
      validate: 'Enregistrer',
    },
    edithousing: 'Modifier le logement',
    editdevice: "Modifier l'appareil",
    housingform: {
      apartment: {
        errorempty: 'Les détails doivent être renseignés.',
      },
      apartmentNumber: {
        label: 'N°',
      },
      batch: {
        label: 'Lot',
      },
      batchtype: {
        label: 'Type de lot',
      },
      datecreate: 'Créé le',
      errorunknown: "Une erreur s'est produite. Veuillez réessayer.",
      phone: {
        label: 'Téléphone du propriétaire',
      },
      floor: {
        label: 'Etage',
      },
      housinggroup: {
        errorempty: 'Un bâtiment doit être sélectionné.',
        label: 'Bâtiment',
        new: 'Nouveau bâtiment',
        placeholder: 'Sélectionnez un bâtiment',
      },
      lastname: {
        label: 'Nom de propriétaire',
      },
      email: {
        label: 'Email du propriétaire',
      },
      loc_phone: {
        label: 'Téléphone du locataire',
      },
      loc_lastname: {
        label: 'Nom du locataire',
      },
      loc_email: {
        label: 'Email du locataire',
      },
      title: 'Ajouter un logement',
      validate: 'Enregistrer',
    },
    housingset: {
      addtitle: 'Ajouter un logement',
      edittitle: 'Modifier un logement',
      ownertitle: 'Propriétaire',
      tenanttitle: 'Locataire',
      tab: {
        housing: 'Logement',
        owner: 'Propriétaire',
        tenant: 'Locataire',
      },
    },
    housingcontacttab: {
      owners: 'Propriétaires',
      tenants: 'Locataires',
      addcontact: 'Ajouter un contact',
      addowner: 'Ajouter un propriétaire',
      addtenant: 'Ajouter un locataire',
      editcontact: 'Modifier le contact',
      nocontacts: 'Aucun contact enregistré',
      savehousingfirst: 'Veuillez d\'abord enregistrer le logement pour gérer les contacts',
      errorloading: 'Erreur lors du chargement des contacts',
      errorsaving: 'Erreur lors de l\'enregistrement',
      nameRequired: 'Le nom est obligatoire',
      confirmdelete: 'Êtes-vous sûr de vouloir supprimer ce contact ?',
      name: 'Nom',
      tel: 'Téléphone',
      email: 'Email',
      save: 'Enregistrer',
      start_date: 'Date de début',
      end_date: 'Date de fin',
      status: 'Statut',
      created: 'Créé le',
      current: 'Actuel',
      'status.active': 'Actuel',
      'status.inactive': 'Ancien',
    },
    housinggroupform: {
      address: {
        label: 'Adresse',
      },
      city: {
        label: 'Ville',
      },
      country: {
        label: 'pays',
      },
      datecreate: 'Créé le',
      errorunknown: "Une erreur s'est produite. Veuillez réessayer.",
      jointhousinggroup: {
        errorempty: 'Une copropriété doit être sélectionnée.',
        label: 'Copropriété',
        new: 'nouvelle copropriété',
        placeholder: 'Sélectionnez une copropriété',
      },
      label: {
        errorempty: 'Un intitulé doit être renseigné.',
        label: 'Intitulé',
      },
      postalcode: {
        label: 'Code postal',
      },
      title: 'Ajouter un bâtiment',
      validate: 'Enregistrer',
    },
    nodevice: 'Aucun appareil',
    nometerreading: 'Aucun relevé',
    adddevice: {
      title: 'Ajouter un appareil',
    },
    sharehousing: 'Gérer les accès du logement',
    showsynthesis: 'Voir le bilan',
    showconsumption: 'Voir la consommation',
    viewdevice: "Voir l'appareil"
  },
  housinggroup: {
    deletehousinggroup: {
      confirm: {
        text: 'Supprimez ce bâtiment ?',
        validate: 'Supprimer',
      },
      error: 'La suppression a échoué. Veuillez réessayez.',
      label: 'Supprimer le bâtiment',
    },
    details: {
      address: 'Adresse : ',
      city: 'Ville : ',
      country: 'Pays : ',
      housinggroup: 'Bâtiment : ',
      jointhousinggroup: 'Copropriété : ',
      postalcode: 'Code postal : ',
    },
    edithousinggroup: 'Modifier le bâtiment',
    errorloading: 'Erreur de chargement',
    housing: {
      apartmentNumber: 'N° : ',
      batch: "Lot : ",
      floor: 'Etage : ',
      name: 'Nom : ',
    },
    nohousing: 'Aucun logement',
    sharehousinggroup: 'Gérer les accès du bâtiment',
  },
  housinggroups: {
    add: 'Ajouter un bâtiment',
    errorloading: 'Erreur de chargement des données',
    jointHousingGroup: {
      none: 'Sélectionnez une copropriété',
    },
    nbhousinggroup_other: '{{count}} bâtiments',
    nbhousinggroup_zero: 'Aucun bâtiment',
    nbhousinggroup_one: '1 bâtiment',
    nohousing: 'Aucun bâtiment trouvé',
    table: {
      label: 'Intitulé',
      address: 'Adresse',
      postalcode: 'Code postal',
      city: 'Ville',
      country: 'Pays',
      jointhousingGroup: 'Copropriété',
    },
    title: 'Les bâtiments',
  },
  housinggroupset: {
    errorloading: 'Erreur de chargement des données',
    housinggroupform: {
      add: {
        title: 'Ajouter un bâtiment',
      },
      address: {
        label: 'Adresse',
      },
      city: {
        label: 'Ville',
      },
      country: {
        label: 'Pays',
      },
      datecreate: 'Créé le',
      edit: {
        title: 'Modifier un bâtiment',
      },
      errorunknown: "Une erreur s'est produite. Veuillez réessayer.",
      jointhousinggroup: {
        errorempty: 'Une copropriété doit être sélectionné.',
        label: 'Copropriété',
        new: 'Nouvelle copropriété',
        placeholder: 'Sélectionnez une copropriété',
      },
      label: {
        errorempty: "L'intitulé doit être renseigné",
        label: 'Intitulé',
      },
      location: {
        auto: "Trouver les coordonnées automatiquement",
        label: "Localisation"
      },
      postalcode: {
        label: 'Code postal',
      },
      validate: 'Enregistrer',
    },
  },
  housings: {
    add: 'Ajouter un logement',
    errorloading: 'Erreur de chargement des données',
    housingGroup: {
      none: 'Sélectionnez un bâtiment',
    },
    jointHousingGroup: {
      none: 'Sélectionnez une copropriété',
    },
    nbhousing_other: '{{count}} logements',
    nbhousing_zero: 'Aucun logement',
    nbhousing_one: '1 logement',
    nohousing: 'Aucun logement trouvé',
    table: {
      batch: 'Lot',
      apartment: 'N°',
      floor: 'étage',
      housingGroup: 'bâtiment',
      owner: 'Propriétaire',
      tenant: 'Locataire',
      name: 'nom',
    },
    title: 'Les logements',
  },
  jointhousinggroup: {
    deletejointhousinggroup: {
      confirm: {
        text: 'Supprimez cette copropriété ?',
        validate: 'Supprimer',
      },
      error: 'La suppression a échoué. Veuillez réessayez.',
      label: 'Supprimer la copropriété',
    },
    details: {
      jointhousinggroup: 'Copropriété : ',
    },
    editjointhousinggroup: 'Modifier la copropriété',
    errorloading: 'Erreur de chargement',
    housinggroup: {
      label: 'Bâtiment : ',
    },
    sharejointhousinggroup: 'Gérer les accès de la copropriété',
    showdocuments: 'Voir les documents',
    showsynthesis: 'Voir le bilan'
  },
  jointhousinggroups: {
    add: 'Ajouter une copropriété',
    errorloading: 'Erreur de chargement des données',
    nbjointhousinggroup_other: '{{count}} copropriétés',
    nbjointhousinggroup_zero: 'Aucun copropriété',
    nbjointhousinggroup_one: '1 copropriété',
    nojointhousinggroup: 'Aucune copropriété trouvée',
    table: {
      label: 'Intitulé',
    },
    title: 'Les copropriétés',
  },
  jointhousinggroupset: {
    errorloading: 'Erreur de chargement des données',
    jointhousinggroupaction: {
      refreshautotable: {
        label: "Régénérer les tables automatiques",
        confirm: {
          // Le suivi d'avancement de #311 remplace l'attente aveugle : la régénération efface les
          // données de la copropriété avant de les reconstruire, d'où l'avertissement explicite.
          text: "Régénérer les tables automatiques de cette copropriété ? Les consommations de la copropriété seront indisponibles le temps du recalcul, qui peut être long. Vous pourrez suivre son avancement et continuer à utiliser l'application.",
          validate: "Régénérer"
        },
        // ⚠️ `error` était appelée par le code sans exister : l'alerte affichait la clé brute.
        error: "La régénération n'a pas pu être menée à son terme. Les consommations affichées peuvent être incomplètes : relancez-la.",
        done: "Régénération terminée. Les consommations sont de nouveau à jour.",
        // Le suivi vit en mémoire du serveur : un redémarrage pendant le recalcul le fait perdre.
        // Le traitement, lui, a pu être interrompu — d'où l'invitation à vérifier puis relancer.
        lost: "Le suivi de la régénération a été perdu, probablement à la suite d'un redémarrage du serveur. Vérifiez les consommations de la copropriété et relancez la régénération si elles sont incomplètes.",
        starting: "Inventaire des compteurs…",
        progress: "{{pourcent}} % — {{traites}} compteurs sur {{total}}",
        warning: "Les consommations de cette copropriété sont temporairement indisponibles, le temps du recalcul."
      }
    },
    jointhousinggroupform: {
      add: {
        title: 'Ajouter une copropriété',
      },
      alarms: {
        updatebox: {
          label: "Relevé boîtier manquant"
        },
        updatecoldwater: {
          label: "Relevé eau froide manquant"
        },
        updatehotwater: {
          label: "Relevé eau chaude manquant"
        },
        updateheater: {
          label: "Relevé chauffage manquant"
        },
        inverseflowheater: {
          label: "Débit chauffage inversé"
        },
        partialnoflow: {
          label: "Débit suspect (entre eau chaude et froide)"
        },
        label: "Alarmes"
      },
      billingdate: {
        label: "Paramétres comptable",
        startmonth: "Début de l'année comptable"
      },
      datecreate: 'Créé le',
      edit: {
        title: 'Modifier une copropriété',
      },
      errorunknown: "Une erreur s'est produite. Veuillez réessayer.",
      label: {
        errorempty: "L'intitulé doit être renseigné",
        label: 'Intitulé',
      },
      meterreadingtype: {
        coldwater: {
          label: "Compteur eau froide"
        },
        heater: {
          label: "Compteur chauffage"
        },
        hotwater: {
          label: "Compteur eau chaude"
        },
        label: "Type de relevé automatique",
        type: {
          annualy: "Annuel",
          biannualy: "Bi-annuel",
          daily: "Journalier",
          none: "Aucun",
          monthly: "Mensuel"
        }
      },

      validate: 'Enregistrer',
    },
    tab: {
      actions: 'Actions',
      details: 'Copropriété',
    }
  },
  keyview: {
    errorloading: "Les données n'ont pas pu être chargées.",
    intro: '',
    intro_10: 'La clé ci-dessous vous permet de créer un compte administrateur. Pour créer votre compte, rendez-vous sur : ',
    intro_20: 'La clé ci-dessous vous permet de créer un compte gestionnaire administrateur. Pour créer votre compte, rendez-vous sur : ',
    intro_21: 'La clé ci-dessous vous permet de créer un compte gestionnaire. Pour créer votre compte, rendez-vous sur : ',
    print: "Imprimer l'invitation",
    sendinvite: "Télécharger l'invitation au format pdf",
  },
  login: {
    errorauthentification:
      "Vos identifiants n'ont pas été reconnus. Veuillez réessayer",
    form: {
      email: 'adresse email',
      forgot: 'Mot de passe oublié ?',
      password: 'mot de passe',
      register: "Vous avez une clé d'accès et pas de compte ? Créez-en un.",
      validate: 'Log in',
      loading: 'Connexion...',
    },
    title: 'Se connecter',
  },
  logout: {
    loading: {
      title: 'Déconnexion en cours...',
      message: 'Veuillez patienter pendant que nous vous déconnectons.'
    },
    error: {
      title: 'Erreur de déconnexion',
      message: 'Une erreur est survenue lors de la déconnexion. Veuillez réessayer.',
      retry: 'Réessayer',
      continue: 'Continuer',
      generic: 'Une erreur inattendue est survenue.'
    }
  },
  layout: {
    popupleakage: {
      noshowagain_one: 'Ne plus afficher cette alerte',
      noshowagain_other: 'Ne plus afficher ces alertes',
      title: 'Fuite détectée',
      text_one: 'Une fuite a été détectée sur le logement suivant, veuillez vérifier vos appareils :',
      text_other: 'Une fuite a été détectée sur les logements suivants, veuillez vérifier vos appareils :',
    },
    popupcontactconsent: {
      text: "Autorisez-vous Compteurs & Compagnie à vous contacter par email ou téléphone en cas de problème détecté sur votre installation ou votre consommation ?\n\nVous pourrez modifier ce choix à tout moment dans votre profil.",
      accept: 'Accepter',
      refuse: 'Refuser'
    }
  },
  map: {
    nbalarm_zero: '',
    nbalarm_one: '1 alarme',
    nbalarm_other: '{{count}} alarmes'
  },
  meters: {
    dateStart: 'Date de début',
    dateEnd: 'Date de fin',
    errorloading: 'Erreur de chargement des données',
    title: "Relevés",
    jointHousingGroup: {
      none: 'Sélectionnez une copropriété',
    },
    housingGroup: {
      none: 'Sélectionnez un bâtiment',
    },
    housing: {
      none: 'Sélectionnez un logement',
    },
    type: {
      none: 'Sélectionnez un type',
    },
    nbmeter_zero: '{{count}} relevé',
    nbmeter_one: '{{count}} relevé',
    nbmeter_other: '{{count}} relevés',
    nometer: "Aucun relevé",
    table: {
      datereading: "Date de relevé",
      index: "Données",
      indexDelta: "Consommation",
      deviceserial: "N° série",
      deviceserialradio: "N° série radio",
      housing: "Logement",
      housinggroup: "Bâtiment",
      jointhousinggroup: "Copropriété",
      origin: "Origine",
      showframe: "Voir le fichier de trames d'origine",
      signal: "Signal"
    }
  },
  navigation: {
    admins: 'Administrateurs',
    buildingmanagers: 'Gestionnaires',
    connect: 'Se connecter',
    devices: 'Appareils',
    disconnect: 'Se déconnecter',
    housings: {
      box: 'Boitiers',
      device: 'Appareils',
      housing: 'Logements',
      housinggroup: 'Bâtiments',
      jointhousinggroup: 'Copropriétés',
      label: 'Logements'
    },
    myaccount: 'Mon compte',
    myprofil: 'Mon profil',
    mynotification: 'Mes notifications',
    adminsettings: 'Paramétrage applicatif',
    adminremoteaccess: 'Accès de télérelevé',
    technicals: 'Techniciens',
    tools: {
      importmeter: 'Importer un fichier de données',
      label: 'Outils',
      syncautometer: {
        alreadyinprogress: 'Une mise à jour et déjà en cours.',
        label: 'Importer les télérelevés',
        result: 'Import des télérelevés terminé',
        done: 'Import des télérelevés terminé',
        // Un import sur trois peut échouer sans empêcher les autres : le dire, au lieu
        // d'annoncer un succès complet
        partial: 'Import des télérelevés terminé, mais sans succès pour : {{sources}}. Vous pouvez relancer l\'import plus tard.',
        sources: {
          webdyn: 'les relevés Webdyn',
          supervision: 'la supervision Webdyn',
          lora: 'les relevés LoRa',
          unknown: 'une source inconnue',
        },
        error: 'Une erreur est survenue lors de l\'import des télérelevés.'
      },
      testframe: "Tester une trame",
      extractreadings: "Extraire les relevés",
      tickets: "Tickets",
      emailtemplates: "Templates d'email",
      testsendalarmemail: {
        alreadyinprogress: 'Une mise à jour et déjà en cours.',
        result: 'email alarme envoyé',
        result_plural: 'emails alarme envoyés',
        label: "Tester l'envoi d'email d'alarme",
        done: 'Email d\'alarme envoyé',
        error: 'Une erreur est survenue lors de l\'envoi de l\'email d\'alarme.'
      },
      updatealarm: {
        alreadyinprogress: 'Une mise à jour et déjà en cours.',
        result: '{{count}} nouvelle alarme',
        result_plural: '{{count}} nouvelles alarmes',
        label: 'Mettre à jour les alarmes',
        done: 'Mise à jour des alarmes terminée',
        error: 'Une erreur est survenue lors de la mise à jour des alarmes.'
      },
      updateautotable: {
        alreadyinprogress: 'Une mise à jour et déjà en cours.',
        done: 'Mise à jour des tables automatiques est finie.',
        error: 'Une erreur est survenue lors de la mise à jour des tables automatiques.',
        label: 'Mettre à jour les tables automatiques'
      },
      updategeolocation: {
        alreadyinprogress: 'Une mise à jour et déjà en cours.',
        done: 'Mise à jour des géolocalisations finie.',
        label: 'Mettre à jour les géolocalisations'
      },
      viewmeters: 'Voir les relevés',
      // Une entrée par accès de télérelevé enregistré : les trois libellés figés
      // (Webdyn, Webdyn supervision, Lora) laissaient de côté tout second serveur
      viewftp: 'Voir les fichiers ftp {{label}}',
      viewalarms: 'Voir les alarmes',
      viewnegativeflow: 'Détecter les flux négatifs',
      ediimport: 'Importer un fichier EDI (LGE)'
    },
    users: 'Utilisateurs'
  },
  needconfirm: {
    title: "Vous devez confirmer votre email.",
    text: "Un email vous a été envoyé lorsque vous vous êtes enregistré. Merci de cliquer sur le lien de cet email pour confirmer vous adresse email."
  },
  notfound: {
    title: 'Page inconnue',
    text: "Désolé, cette page n'existe pas.",
  },
  profile: {
    title: "Mon profil",
    editprofile: "Modifier le profile",
    errorloading: "Les données n'ont pas pu être chargées.",
    form: {
      accountdisplayed: {
        title: "Compte affiché"
      },
      address: {
        title: "Adresse"
      },
      error_profileSet_notAuthentified: "Erreur d'authentification, veuillez vous reconnecter.",
      error: "Une erreur s'est produite, veuillez réessayer.",
      city: {
        title: "Ville"
      },
      country: {
        title: "Pays"
      },
      label: {
        title: "libellé"
      },
      email: {
        title: "Email"
      },
      postalcode: {
        title: "Code postal"
      },
      tel: {
        title: "Téléphone"
      },
      usergrouplabel: {
        title: "Groupe"
      },
      contactconsent: {
        title: "Contact en cas de problème",
        label: "J'autorise Compteurs & Compagnie à me contacter par email ou téléphone en cas de problème détecté sur mon installation ou ma consommation.",
        accepted: "Autorisé",
        refused: "Non autorisé",
        undefined: "Non renseigné"
      },
      login: {
        title: "Identifiant"
      },
      password: {
        modify: "Modifier",
        title: "Mot de passe"
      },
      validate: "Enregistrer"
    },
    setpassword: {
      form: {
        error_passwordSet_notAuthentified: "Erreur d'authentification, veuillez vous reconnecter.",
        error_passwordSet_wrongConfirmation: "Le nouveau mot de passe ne correspond pas à sa confirmation.",
        error_passwordSet_passwordWrongFormat: "Le mot de passe doit contenir au minimum 8 caractères, une majuscule, une minuscule et un chiffre",
        error_passwordSet_wrongPasswordOld: "L'ancien mot de passe n'est pas le bon.",
        error: "Une erreur s'est produite, veuillez réessayer.",
        confirm: {
          title: "Confirmer le mot de passe"
        },
        new: {
          title: "Nouveau mot de passe"
        },
        old: {
          title: "Ancien mot de passe"
        }
      },
      title: "Modifier mon mot de passe"
    }
  },
  recovery: {
    form: {
      confirmpassword: "Confirmation mot de passe",
      error_fieldEmpty: "Tous les champs doivent être renseignés.",
      error_keyUnknown: "La clé est inconnue. Veuillez vérifier les informations saisies.",
      error_passwordConf: "Le mot de passe et sa confirmation sont différents. Veuillez vérifier les informations saisies.",
      error_passwordWrongFormat: "Le mot de passe doit contenir au minimum 8 caractères, une majuscule, une minuscule et un chiffre",
      error_userNotFound: "L'identifiant ne correspond pas ou le lien de réactivation n'est plus valable.",
      error_loginKeyMissMatch: "L'identifiant ne correspond pas ou le lien de réactivation n'est plus valable.",
      error: "Une erreur s'est produite, veuillez réessayer.",
      login: "Identifiant",
      newpassword: "Nouveau mot de passe",
      text: "Veuillez entrer votre identidiant, ainsi que le nouveau mot de passe.",
      validate: "Enregistrer"
    },
    title: "Réinitialisation du mot de passe"
  },
  register: {
    error:
      "La création de compte n'a pu aboutir. Si le problème persiste, veuillez contacter le service client.",
    error_emailAlreadyUsed: 'Cette adresse email a déjà un compte.',
    error_emailFormat:
      "L'email est invalide. Veuillez vérifier les informations saisies.",
    error_fieldMissing: 'Tous les champs doivent être remplis.',
    error_keyAlreadyUsed: "Cette clé n'est plus valide.",
    error_keyExpired: "Cette clé n'est plus valide.",
    error_keyUnknown:
      'La clé est inconnue. Veuillez vérifier les informations saisies.',
    error_passwordConf:
      'Le mot de passe et sa confirmation sont différents. Veuillez vérifier les informations saisies.',
    error_passwordWrongFormat:
      'Le mot de passe doit contenir au minimum 8 caractères, une majuscule, une minuscule et un chiffre',
    form: {
      email: 'Adresse email',
      key: 'Clé',
      password: 'Mot de passe',
      passwordconf: 'Confirmation mot de passe',
      validate: 'Envoyer',
      loading: 'Création du compte...',
      contactConsent: "J'autorise Compteurs & Compagnie à me contacter par email ou téléphone en cas de problème détecté sur mon installation ou ma consommation.",
    },
    title: 'Nouveau compte',
  },
  sendemailalarm: {
    cols: {
      jointhousinggroup: "Copropriété",
      housinggroup: "Bâtiment",
      housing: "Logement",
      radioserial: "N° radio",
      serial: "N° de série",
      type: "Type",
      status: "Statut",
      attribute: "Détails"
    },
    key: {
      lastMeterDate: "Dernier relevé",
      dateReading: "Date de lecture"
    }
  },
  sendnotif: {
    errorloading: "Les données n'ont pas pu être chargées.",
    errornoemail: "L'utilisateur n'a pas d'adresse email renseignée.",
    errorsetstatus: "La modification a échoué.",
    errorsend: "L'envoi a échoué.",
    hideforuser: "Masquer pour l'utilisateur",
    showforuser: "Afficher pour l'utilisateur",
    table: {
      action: "Action",
      type: "Type d'alarme",
      date: "Date",
      jointHousingGroup: "Copropriété",
      housingGroup: "Bâtiment",
      housing: "Logement",
      deviceType: "Type d'appareil",
      device: "N° de série",
    },
    send: "Envoyer",
    sent: "Notification envoyée",
    title: "Envoyer une alarme par email à "
  },
  emailreporthistory: {
    title: "Rapports d'alarmes envoyés",
    empty: "Aucun rapport n'a encore été envoyé à cette adresse.",
    loading: "Chargement de l'historique…",
    loaderror: "L'historique n'a pas pu être chargé.",
    norow: "Ce rapport ne contenait aucune alarme.",
    // `_zero` et non `_0` : i18next 23 resout les pluriels par `Intl.PluralRules`, qui
    // classe zero dans la categorie « one » en francais. Sous `_0`, un rapport vide
    // s'affichait « 1 alarme ».
    alarmcount_zero: "aucune alarme",
    alarmcount_one: "1 alarme",
    alarmcount_other: "{{count}} alarmes"
  },
  setnotification: {
    errorloading: "Les données n'ont pas pu être chargées.",
    form: {
      alarms: {
        daily: "Quotidien",
        monthly: "Mensuel (le 1er)",
        none: "Aucun",
        weekly: "Hebdomadaire (lundi)",
        title: "Rapport des alarmes (email)"
      },
      error: "Une erreur s'est produite, veuillez réessayer.",
      leakagealarm: "Recevoir un email lors d'une supicion de fuite",
      absencealarm: "Signaler une période d'absence",
      absenceStart: "Date de début",
      absenceEnd: "Date de fin",
      consumptionThresholdAlarm: "Recevoir un email en cas de dépassement de seuil de consommation",
      thresholdHelp: "Définissez un seuil mensuel et/ou annuel pour les types d'appareil que vous souhaitez surveiller. Laissez vide pour ne pas surveiller.",
      thresholdMonthly: "Seuil mensuel ({{unit}})",
      thresholdYearly: "Seuil annuel ({{unit}})",
      validate: "Enregistrer"
    },
    title: "Gérer mes notifications"
  },
  synthesis: {
    device: {
      comment: 'Remarque',
      comment_commissioning: "* Mise en service",
      consumption: 'Consommation',
      description: 'Description',
      index: '{{date}}',
      intermediate: '{{date}}',
      location: "Emplacement",
      report: '{{date}}',
      serial: 'N° de série',
      total: 'Total',
      type: 'Type'
    },
    enddate: "Fin",
    errorloading: "Les données n'ont pas pu être chargées.",
    forfait: "Utiliser les forfaits",
    generateinprogress: "Génération du xls en cours ...",
    housing: {
      apartmentNumber: "Appt N° : ",
      batch: "Lot N° : ",
      floor: "Etage : ",
      owner: "Propriétaire : ",
      tenant: "Locataire : "
    },
    housinggroup: {
      label: "Bâtiment : ",
      type_heater: "chauffage",
      type_sanitary: "sanitaire"
    },
    jointhousinggroup: {
    },
    middledate: "Milieu",
    savexls: "Enregistrer le xls",
    startdate: "Début",
    summary: "Présentation",
    title: "Bilan"
  },
  consumption: {
    title: "Consommation journalière",
    errorloading: "Les données n'ont pas pu être chargées.",
    startdate: "Date de début",
    enddate: "Date de fin",
    exportexcel: "Enregistrer le xls",
    exportcsv: "Enregistrer le csv",
    generateinprogress: "Génération en cours ...",
    device: {
      serial: "N° de série",
      location: "Emplacement",
      date: "Date",
      index: "Index",
      dailyConsumption: "Conso/Jour",
      consumption: "Consommation",
      cumulativeConsumption: "Consommation"
    },
    housing: {
      batch: "Lot N° : ",
      apartmentNumber: "Appt N° : ",
      owner: "Propriétaire : ",
      tenant: "Locataire : ",
      floor: "Etage : "
    },
    housinggroup: {
      label: "Bâtiment : ",
      type_heater: "chauffage",
      type_sanitary: "sanitaire"
    },
    coldWater: "Eau Froide",
    hotWater: "Eau Chaude",
    heater: "Chauffage",
    water: "Eau",
    period: "Période du {{startDate}} au {{endDate}}",
    noData: "Aucune donnée disponible pour la période sélectionnée",
    singleReadingPerDay: "1 relevé par jour"
  },
  tools: {
    title: "Test trame",
    testframe: {
      form: {
        button: "Valider",
        label: "Trame à décrypter"
      },
      resultall: {
        label: "Résultat complet"
      },
      resultdecrypted: {
        label: "Trame décryptée"
      }
    }
  },
  extractreadings: {
    title: "Extraire les relevés",
    accessrefused: "Accès refusé : cette page est réservée aux super administrateurs.",
    form: {
      uid: "Numéro de boîtier",
      uidPlaceholder: "ex : 412615",
      serialRadio: "Numéro de compteur (serialRadio)",
      serialRadioPlaceholder: "ex : 12345678",
      // Une case par accès de télérelevé : les libellés viennent des accès enregistrés,
      // les deux cases figées « Webdyn » et « LoRa » laissaient de côté les autres serveurs
      sources: "Sources FTP",
      dateStart: "Date de début (optionnel)",
      dateEnd: "Date de fin (optionnel)",
      submit: "Extraire",
      download: "Télécharger Excel"
    },
    error: {
      argMissing: "Veuillez renseigner le boîtier, le compteur et au moins une source.",
      generic: "Une erreur est survenue lors de l'extraction."
    },
    table: {
      date: "Date",
      serialRadio: "Compteur",
      type: "Type",
      index: "Index / Volume",
      energy: "Énergie",
      flow: "Flow",
      alarms: "Alarmes",
      signal: "Signal",
      source: "Source"
    },
    nbreadings_zero: "Aucun relevé",
    nbreadings_one: "{{count}} relevé",
    nbreadings_other: "{{count}} relevés",
    noresult: "Aucun relevé trouvé pour ce compteur."
  },
  underconstruction: {
    title: 'Page en construction',
  },
  usergroups: {
    title_20: 'Gestionnaire',
    title_30: 'Groupe de technicien',
    add_20: 'Ajouter un gestionnaire',
    add_30: 'Ajouter un groupe de technicien',
    errorloading: "Les données n'ont pas pu être chargées.",
    grouplist: {
      nousergroup_20: 'Aucun gestionnaire ',
      nousergroup_30: 'Aucun groupe de technicien',
      table: {
        name: 'Login',
        datecreation: 'Date de création',
        status: 'status',
        member: 'membre',
        view: 'Voir',
      },
    },
    nbusergroup_20: '{{count}} gestionnaire',
    nbusergroup_20_plural: '{{count}} gestionnaires',
    nbusergroup_30: '{{count}} groupe de technicien',
    nbusergroup_30_plural: '{{count}} groupes de technicien',
  },
  usergroupset: {
    errorloading: "Les données n'ont pas pu être chargées.",
    form: {
      address: {
        label: 'Adresse',
        street: 'Rue, numéro, étage',
        postalcode: 'Code postal',
        city: 'Ville',
        country: 'Pays',
      },
      datecreate: 'Créée le',
      deactivate: 'Suspendre',
      name: 'Nom',
      reactivate: 'Reconduire',
      tel: 'Téléphone',
      validate_add: 'Enregistrer',
      validate_modify: 'Modifier',
    },
    title_20: 'Gestionnaire',
    title_30: 'Groupe de technicien',
  },
  usergroup: {
    createaccess: 'Créer un accès utilisateur',
    createaccess_10: 'Créer un accès administrateur',
    createaccess_20: 'Créer un accès pour ce gestionnaire',
    createaccess_30: 'Créer un accès pour ce groupe',
    errorloading: "Les données n'ont pas pu être chargées.",
    details: {
      address: 'Adresse',
      datecreate: 'Créée le',
      status: 'Status',
      name: 'Nom',
      tel: 'Téléphone',
      modify: 'Modifier',
    },
    housing: {
      none: "Tous les logements de ce bâtiment"
    },
    housinggroup: {
      none: "Tous les bâtiments de cette copropriété"
    },
    jointhousinggroup: {
      none: "Toutes les copropriétés"
    },
    nbuser: '{{count}} utilisateur',
    nbuser_plural: '{{count}} utilisateurs',
    nbuser_10: '{{count}} administrateur',
    nbuser_10_plural: '{{count}} administrateurs',
    tab: {
      users: "Membres",
      accesses: "Accès"
    },
    title: 'Utilisateur',
    title_10: 'Administrateur',
    title_20: 'Gestionnaire',
    title_30: 'Groupe de technicien',
    userlist: {
      add: 'Ajouter un utilisateur',
      add_10: 'Ajouter un administrateur',
      downloadinvites: 'Télécharger les invitations au format pdf',
      noleakagenotification: 'L\'utilisateur a désactivé les notifications de fuite',
      nouser: 'Aucun utilisateur',
      nouser_10: 'Aucun administrateur',
      showsuspended: 'Afficher les comptes suspendus',
      table: {
        label: 'Libellé',
        leakagealarms: 'Fuite à notifier',
        leakagealarmstitle: 'Envoyer un email d\'alarme de fuite',
        datecreate: 'Date de création',
        status: 'Status',
        type: 'Type',
        email: 'Email',
        tel: 'Téléphone',
        contactconsent: 'Contact autorisé',
      },
      title: 'Utilisateurs',
      title_10: 'Administrateurs',
      modify: 'Modifier',
    },
    accesslist: {
      title: "Acces du groupe"
      , add: "Ajouter un accès"
      , noaccess: "Aucun accès"
      , table: {
        label: "Elément partagé"
        , datestart: "Date de début"
        , dateend: "Date de fin"
        , status: "Status"
        , type: "type"
        , typefromgroup: "Hérité du groupe"
        , typefromparam: "Paramétré"
      }
    }
  }
  , user: {
    errorloading: "Les données n'ont pas pu être chargées."
    , details: {
      label: 'Libellé',
      datecreate: 'Créée le',
      email: 'Email',
      status: 'Status',
      tel: 'Téléphone',
      address: 'Adresse',
      modify: 'Modifier',
      type: 'Type',
      viewkey: 'Voir la clé'
    },
    noaccess: "Pas d'access",
    accesslist: {
      title: "Acces de l'utilisateur"
      , add: "Ajoute un accès"
      , noaccess: "Aucun accès"
      , table: {
        label: "Elément partagé"
        , datestart: "Date de début"
        , dateend: "Date de fin"
        , status: "Status"
        , type: "type"
        , typefromgroup: "Hérité du groupe"
        , typefromparam: "Paramétré"
      }
    }
  },
  usermulti: {
    accessstatus: {
      all: "Tous les logements",
      with: "Logement avec accès",
      without: "Logement sans accès"
    },
    downloadinvites: {
      button: "Télécharger les invitations au format pdf",
      error: "Le pdf n'a pas pu être créer"
    },
    errorloading: "Les données n'ont pas pu être chargées.",
    housingGroup: {
      none: "Sélectionnez un logement"
    },
    housinglist: {
      createusers: "Créer des nouveaux accès utilisateur"
    },
    jointHousingGroup: {
      none: "Sélectionnez une copropriété"
    },
    nbcreated_other: '{{count}} utilisateurs créés. Voulez-vous télécharger les invitations ?',
    nbcreated_zero: 'Aucun utilisateur créé.',
    nbcreated_one: "1 utilisateur créé. Voulez-vous télécharger l'invitation ?",
    nbhousing_other: '{{count}} logements',
    nbhousing_zero: 'Aucun logement',
    nbhousing_one: '1 logement',
    nohousing: "Aucun logement",
    nbselected_other: '{{count}} logements sélectionnés',
    nbselected_one: '1 logement sélectionné',
    table: {
      batch: 'Lot',
      apartment: 'N°',
      floor: 'étage',
      housingGroup: 'bâtiment',
      name: 'nom',
    },
    title: "Ajouter des utilisateurs aux logements"
  },
  userset: {
    errorloading: "Les données n'ont pas pu être chargées.",
    title: {
      add: 'Ajouter un utilisateur',
      add_10: 'Ajouter un administrateur',
      modify: 'Modifier un utilisateur',
      modify_10: 'Modifier administrateur'
    },
    titlegroup: '(membre de {{name}})',
    form: {
      address: {
        label: 'Adresse',
        street: 'Rue, numéro, étage',
        postalcode: 'Code postal',
        city: 'Ville',
        country: 'Pays',
      },
      datecreate: 'Créée le',
      deactivate: 'Suspendre',
      resendactivation: 'Renvoyer le mail d\'activation',
      activationresent: 'Mail d\'activation renvoyé.',
      transfer: 'Transférer la propriété',
      transferred: 'Propriété transférée.',
      delete: 'Supprimer définitivement',
      deleteconfirm: 'Confirmer la suppression',
      deleteconfirmquestion: 'Supprimer définitivement ce compte ?',
      ownersearch: 'Rechercher un compte par nom ou email…',
      noowner: 'Aucun compte correspondant',
      ownersloading: 'Chargement…',
      transfermandatory: 'Ce compte a des comptes liés : le transfert vers un autre propriétaire est obligatoire pour pouvoir le supprimer.',
      email: {
        alreadyused: 'Cette adresse email est déjà associée à un compte.',
        label: 'Email'
      },
      label: {
        label: 'Libellé',
        errorempty: 'Le libellé doit être renseigné'
      },
      reactivate: 'Reconduire',
      status: 'Status',
      tel: 'Téléphone',
      type: 'Type',
      validate_add: 'Créer un nouvel accès utilisateur',
      validate_modify: 'Modifier',
    },
  }
};
